import React, { useEffect, useRef } from 'react';
import { useInView } from '../../../hooks/useInView';
import { buildCloudinaryImageUrl } from '../../../utils/CloudinaryImageUrl';

export const HeroStack = ({ banners }) => {



    const texto = useInView({ threshold: 0.15, once: true });
    const imagen = useInView({ threshold: 0.15, once: true });

    const textoSideClass =
        banners.type !== "right" ? "reveal-from-left" : "reveal-from-right";

    return (
        <>


            <section className="hero">                  <div className="container position-relative">


                <div className="row align-items-center hero-section g-0">
                    {/* Bloque de texto */}
                    <div
                        ref={texto.ref}
                        className={`col-lg-6 ${texto.inView ? `reveal ${textoSideClass}` : "pre-reveal"
                            }`}
                    >
                        <div className="hero-content-stack">
                            <h1>{banners.title}</h1>
                            <p className="hero-subtitle">{banners.description}</p>
                        </div>
                    </div>

                    {/* Bloque de imagen */}
                    <div ref={imagen.ref} className={`col-lg-6 ${imagen.inView ? "reveal reveal-slideUp" : "pre-reveal"}`}>
                        <div className="hero-image-wrapper">
                            <div className="image-container">
                                <img
                                    src={buildCloudinaryImageUrl({ url: banners?.url, width: 1200, quality: "auto", type: "image" })}
                                    loading="lazy"
                                    alt="Pancakes con miel"
                                    className="hero-img img-fluid"
                                />
                            </div>
                        </div>
                    </div>
                </div>




                <div className="row align-items-center d-none">

                    <div className={banners.type !== "right" ? "col-lg-6 order-1  " : "col-lg-6  "} >
                        <div className="hero-content-stack">
                            <h1>{banners.title}</h1>
                            <p className="hero-subtitle">
                                {banners.description}
                            </p>

                            {/* <div class="feature-grid">
                            <div class="feature">
                                <div class="feature-icon">
                                    <i class="fas fa-truck"></i>
                                </div>
                                <div class="feature-text">
                                    <span class="feature-title">Envío gratuito</span>
                                    <span class="feature-desc">desde €50</span>
                                </div>
                            </div>

                            <div class="feature">
                                <div class="feature-icon">
                                    <i class="fas fa-shield-alt"></i>
                                </div>
                                <div class="feature-text">
                                    <span class="feature-title">Garantía</span>
                                    <span class="feature-desc">de frescura</span>
                                </div>
                            </div>

                            <div class="feature">
                                <div class="feature-icon">
                                    <i class="far fa-clock"></i>
                                </div>
                                <div class="feature-text">
                                    <span class="feature-title">Entrega rápida</span>
                                    <span class="feature-desc">en 24 horas</span>
                                </div>
                            </div>
                        </div> */}

                            {/* <div className="cta-buttons">
                                    <button className="btn-primary-modern">
                                        {banners.button.text}
                                        <i className="fas fa-arrow-right"></i>
                                    </button>
                                     <button className="btn-secondary-modern">
                                        Ver Catálogo
                                    </button> 
                                </div>  */}
                        </div>
                    </div>

                    <div className="col-lg-6 ">
                        <div clasNames="hero-image-wrapper">
                            <div className="image-container">
                                <img src={buildCloudinaryImageUrl({ url: banners?.url, width: 1200, quality: "auto", type: "image" })} loading="lazy"
                                    alt="Pancakes con miel"
                                    className="hero-img" />

                                {/* <div class="floating-badge quality-badge  text-bg-primary">
                                        <i class="fas fa-star"></i>
                                        <span>Calidad Premium</span>
                                    </div>

                                    <div class="floating-badge fresh-badge text-bg-light">
                                        <div class="dot"></div>
                                        <span>Productos Frescos</span>
                                    </div>  */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </section>






        </>
    )
}
